import { WidgetDataTypes } from 'domain/entity/widgetData';

type WidgetChangingProps = { data: WidgetDataTypes; width?: number; height?: number; isLoading?: boolean };

export const checkMemoChanges = (prevProps: WidgetChangingProps, nextProps: WidgetChangingProps): boolean =>
    JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data) &&
    prevProps.width === nextProps.width &&
    prevProps.height === nextProps.height &&
    prevProps.isLoading === nextProps.isLoading;
